import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import "./index.css";
import { appQueryClient } from "./query-client";
import { ssoClient } from "./lib/sso-client";
import { useAuthStore, waitForHydration } from "./stores/auth-store";
import { startRefreshTimer } from "./lib/token-refresh";

const router = createBrowserRouter([{ path: "*", element: <App /> }]);

async function initializeAuth() {
  if (!ssoClient) return;

  await waitForHydration();

  const { refreshToken, realm, setTokens, clearTokens } =
    useAuthStore.getState();

  if (!refreshToken || !realm) return;

  ssoClient
    .refreshToken(refreshToken, realm)
    .then((tokens) => {
      setTokens(tokens);
      startRefreshTimer(Date.now() + tokens.expires_in * 1000);
    })
    .catch(() => {
      clearTokens();
    });
}

initializeAuth();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={appQueryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
);
